import moment, { Moment } from 'moment/moment'

export interface WebhookLogPayload {
    id: number
    rc_event_id: string
    user_id: number | null
    type: string
    payload: any
    processed_at: string | null
    created_at: string | null
}

export class WebhookLog {

    id: number
    rcEventId: string
    userId: number | null
    type: string
    webhookPayload: any
    processedAt: Moment | null
    createdAt: Moment | null

    constructor(data: WebhookLogPayload) {
        this.id = data.id
        this.rcEventId = data.rc_event_id
        this.userId = data.user_id
        this.type = data.type
        this.webhookPayload = data.payload
        this.processedAt = null
        this.createdAt = null

        this.capture(data)
    }

    fill(data: WebhookLogPayload): this {
        this.id = data.id
        this.rcEventId = data.rc_event_id
        this.userId = data.user_id
        this.type = data.type
        this.webhookPayload = data.payload

        this.capture(data)

        return this
    }

    capture(data: WebhookLogPayload): this {
        this.processedAt = data.processed_at ? moment(data.processed_at) : null
        this.createdAt = data.created_at ? moment(data.created_at) : null

        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
    }

    payload(): WebhookLogPayload | any {
        return {
            id: this.id,
            rc_event_id: this.rcEventId,
            user_id: this.userId,
            type: this.type,
            payload: this.webhookPayload,
            processed_at: this.processedAt ? this.processedAt.toISOString() : null,
            created_at: this.createdAt ? this.createdAt.toISOString() : null,
        }
    }
}
